import React from 'react'
import PropTypes from 'prop-types';
import { ResourceEnumCreator, Icons } from '@leverege/api-attributes';
import { ValueCard } from '~/views';

export default class StringViewer extends React.Component {

  static TYPE = ResourceEnumCreator.typeName();

  static propTypes = {
    device : PropTypes.object,
    attribute : PropTypes.object,
    blueprint : PropTypes.object,
    name : PropTypes.string
  }

  render() {
    const { attribute : attr, name, onClick, editable, value } = this.props
    if ( attr == null ) {
      return <div />
    }

    let val = null // '---'
    let valid = true
    if ( typeof value === 'string' ) {
      val = value
    } else if ( value != null ) {
      valid = false
    }
    
    const icon = Icons.getIcon( attr )
    return (
      <ValueCard valid={valid} editable={editable} name={name || attr.name} value={val} icon={icon} onClick={onClick} />
    )
  }
}
